module.exports = __webpack_public_path__ + "img/img_login_sponsor.66e89825.webp";